<template>
  <v-main class="pa-4" fluid>
    <v-row >

      <v-snackbar v-model="alerta.activo" vertical top right :color="alerta.color" > 
        <strong> {{alerta.texto}} </strong>
        <template v-slot:action="{ attrs }">
          <v-btn dark text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
        </template>
      </v-snackbar>
      
      <v-col cols="12">
        <v-card class="shadowCard" :height="pantallaMaquilador">

          <v-card-title primary-title>
	  		    <span class="text-h5 font-weight-bold"> Maquilaciones </span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn color="secondary" dark small class="mr-2" @click="initialize()">
              Actualizar
            </v-btn>
	  		  </v-card-title>

          <v-container style="height: 300px;" v-if="Loading">
            <loading/>
          </v-container>
          
          <v-tabs color="primary" centered  icons-and-text v-else >
            <v-tab><span class=" hidden-sm-and-down">Pendientes  </span>  <v-icon>mdi-gift-open-outline     </v-icon></v-tab>
            <v-tab><span class=" hidden-sm-and-down">Por Entregar</span>  <v-icon>mdi-bike-fast             </v-icon></v-tab>
            <v-tab><span class=" hidden-sm-and-down">Entregado   </span>  <v-icon>mdi-account-heart-outline </v-icon></v-tab>

            <v-tab-item class="pa-4">
              <v-row class="py-5">
                <v-col cols="12" v-if="!pendientes.length && !Loading">
                  <v-alert icon="mdi-shield-lock-outline" prominent text type="error" class="overline">
                    No hay registros para mostrar actualmente, Recargue la información o espere a que haya pedidos.
                  </v-alert>
                </v-col>

                <v-col
                  cols="12" sm="6" md="4" xl="3"
                  class="pa-4"
                  v-else
                  v-for="(item , i) in pendientes" :key="i"
                >
                  <v-card height="95%"  class="shadowCard ">
                    <v-list color="black" dark subheader two-line>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title class="text-h6"> # Pedido  {{ item.idpedidos }}</v-list-item-title>
                          <v-list-item-subtitle ></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content class="text-right">
                          <v-list-item-title class="font-weight-black text-h5" >
                            {{ item.tiempo }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>

                    <v-simple-table  fixed-header height="250px">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left"> Código   </th>
                            <th class="text-left"> Artículo </th>
                            <th class="text-left"> Cantidad </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item2 in item.articulos" :key="item2.idproducto">
                          <!-- <tr v-for="(item2 , j) in 20" :key="j"> -->
                            <td>{{ item2.codigo }}</td>
                            <td>{{ item2.nomart }}</td>
                            <td>{{ item2.cantidad }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                  
                  <div class="my-1"></div>
                  <v-footer class="pa-0" flat>
                    
                    <v-btn
                      v-if="item.proceso == 1"
                      color="blue"
                      class="text-center elevation-8"
                      block dark 
                      @click="validarCambioEstatus(2, item)"
                    > Comenzar a Maquilar
                    </v-btn>

                    <v-btn
                      v-if="item.proceso == 2"
                      color="success"
                      class="text-center elevation-8"
                      block dark 
                      @click="validarCambioEstatus(3, item)"
                    > Terminar Maquila
                    </v-btn>

                    <v-btn
                      v-if="item.proceso == 3"
                      color="secondary"
                      class="text-center elevation-8"
                      block dark 
                      @click="modalAsignarRepartidor = true; parametros = item"
                    > Asignar Repartidor
                    </v-btn>

                    
                    <v-btn
                      v-if="item.proceso == 4"
                      color="orange"
                      class="text-center elevation-8"
                      block dark 
                      @click=""
                    > Por entregar
                    </v-btn>
                                      
                    <v-btn
                      v-if="item.proceso == 5"
                      color="blue"
                      class="text-center elevation-8"
                      block dark 
                      @click=""
                    > Por entregar
                    </v-btn>
                  
                  <!-- <span v-if="item.estatus">
                    <v-btn
                      color="primary"
                      class="text-center"
                      block dark 
                      @click="
                        finalizar_orden_modal = true;
                        itemAEditar = item;
                      "
                    > FINALIZAR ORDEN
                    </v-btn>
                  </span> -->
                  </v-footer>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item class="pa-4">
              <v-row class="py-5">
                <v-col cols="12" v-if="!porEntregar.length && !Loading">
                  <v-alert icon="mdi-shield-lock-outline" prominent text type="error" class="overline">
                    No hay registros para mostrar actualmente, Recargue la información o espere a que haya pedidos.
                  </v-alert>
                </v-col>

                <v-col
                  cols="12" sm="6" md="4" xl="3"
                  class="pa-4"
                  v-else
                  v-for="(item , i) in porEntregar" :key="i"
                >
                  <v-card height="95%"  class="shadowCard ">
                    <v-list color="black" dark subheader two-line>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title class="text-h6"> # Pedido  {{ item.idpedidos }}</v-list-item-title>
                          <v-list-item-subtitle ></v-list-item-subtitle>
                        </v-list-item-content>
                     
                      </v-list-item>
                    </v-list>

                    <v-simple-table  fixed-header height="250px">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left"> Código   </th>
                            <th class="text-left"> Artículo </th>
                            <th class="text-left"> Cantidad </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item2 in item.articulos" :key="item2.idproducto">
                          <!-- <tr v-for="(item2 , j) in 20" :key="j"> -->
                            <td>{{ item2.codigo }}</td>
                            <td>{{ item2.nomart }}</td>
                            <td>{{ item2.cantidad }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>

                    <v-card-actions flat class="mt-12" v-if="item.proceso == 4"/>
                    <v-footer absolute class="text-caption pa-0" v-if="item.proceso == 4">
                      <v-card-text>
                        <span> Repartidor: <strong> {{ item.nombre_repartidor }}</strong> </span> <br>
                        <span> Asignación: <strong> {{ moment(item.asignacion_repartidor).format('LLLL') }} </strong> </span>
                      </v-card-text>
                    </v-footer>

                  </v-card>
                  
                  <div class="my-1"></div>
                  <v-footer class="pa-0" flat>
                    <v-btn
                      v-if="item.proceso == 5"
                      color="blue"
                      class="text-center elevation-8"
                      block dark 
                    > Por entregar
                    </v-btn>
                  </v-footer>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item class="pa-4">
           
              <v-row class="py-5">
                <v-col cols="12" v-if="!entregados.length && !Loading">
                  <v-alert icon="mdi-shield-lock-outline" prominent text type="error" class="overline">
                    No hay registros para mostrar actualmente, Recargue la información o espere a que haya pedidos.
                  </v-alert>
                </v-col>

                <v-col
                  cols="12" sm="6" md="4" xl="3"
                  class="pa-4"
                  v-else
                  v-for="(item , i) in entregados" :key="i"
                >
                  <v-card height="95%"  class="shadowCard ">
                    <v-list color="black" dark subheader two-line>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title class="text-h6"> # Pedido  {{ item.idpedidos }}</v-list-item-title>
                          <v-list-item-subtitle ></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>

                    <v-simple-table  fixed-header height="250px">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left"> Código   </th>
                            <th class="text-left"> Artículo </th>
                            <th class="text-left"> Cantidad </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item2 in item.articulos" :key="item2.idproducto">
                          <!-- <tr v-for="(item2 , j) in 20" :key="j"> -->
                            <td>{{ item2.codigo }}</td>
                            <td>{{ item2.nomart }}</td>
                            <td>{{ item2.cantidad }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>

                    <v-card-actions flat class="mt-12" v-if="item.proceso == 4"/>
                    <v-footer absolute class="text-caption pa-0" v-if="item.proceso == 4">
                      <v-card-text>
                        <span> Repartidor: <strong> {{ item.nombre_repartidor }}</strong> </span> <br>
                        <span> Asignación: <strong> {{ moment(item.asignacion_repartidor).format('LLLL') }} </strong> </span>
                      </v-card-text>
                    </v-footer>

                  </v-card>
                  
                  <div class="my-1"></div>
                  <v-footer class="pa-0" flat>
                    <v-btn
                      v-if="item.proceso == 5"
                      color="blue"
                      class="text-center elevation-8"
                      block dark 
                    > Por entregar
                    </v-btn>
                  </v-footer>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs>

        </v-card>
      </v-col>

      <v-dialog v-model="modalCambioEstatus" persistent width="500">
        <v-card>
          <v-card-title class="subtitle-1 font-weight-black " style="word-break:normal;">
            
            <span v-if="proceso == 2"> ¿ESTÁS SEGURO DE QUERER COMENZAR A MAQUILAR   ? </span>
            <span v-if="proceso == 3"> ¿ESTÁS SEGURO DE QUERER TERMINAR DE MAQUILAR  ? </span>
            <span v-if="proceso == 4"> ¿ESTÁS SEGURO DE QUERER ASIGNAR REPARTIDOR    ? </span> 
          </v-card-title>
          <v-divider class="my-0 py-3" ></v-divider>
          <v-card-subtitle align="center" class="red--text font-weight-bold "> 
            UNA VEZ PROCESADA NO SE PODRÁ RESTABLECER 
          </v-card-subtitle>
          <v-divider class="my-0 py-2 " ></v-divider>

          <v-card-text class="py-0">
            <v-textarea
              filled
              v-model="obs"
              label="Agrega un comentario"	
              rows="3"  
              placeholder="Escribe aquí tus comentarios..." >
            ></v-textarea>
          </v-card-text>

          <v-card-actions >
            <v-btn color="error" dark @click="modalCambioEstatus=false" >  NO, Cancelar </v-btn>
            <v-spacer/>
            <v-btn color="primary" text @click="cambiarEstatusMquilador()" >  SÍ, Procesar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>  
      
      <v-dialog v-model="modalAsignarRepartidor" width="500">
        <v-card class="pa-4">
          <controlRepartidor 
          :parametros="parametros"
          @modal="modalAsignarRepartidor = $event;" 
          @init="finalizarProceso()" />
        </v-card>
      </v-dialog>
        
      <overlay v-if="overlay"/>

    </v-row>
  </v-main>
</template>

<script>
  import Vue from 'vue'
  import  metodos from '@/mixins/metodos.js';
	import {mapGetters, mapActions} from 'vuex'
  import loading from '@/components/loading.vue'
  import overlay from '@/components/overlay.vue'
  import controlRepartidor from '@/views/administrativo/Maquiladores/control_repartidor.vue'
  
  export default {
    mixins:[metodos],
    components: {
      loading,
      overlay,
			controlRepartidor,
		},
    data: () => ({
      pedidos:[],
      contador: 0,

      alerta: { activo: false, texto:'', color:'error' },
      Loading: false,
      overlay :false,
      
      modalAsignarRepartidor: false, 
      modalCambioEstatus:false,
      proceso: 1,
      parametros: {},
      obs: '',

      pendientes: [],
      porEntregar:[],
      entregados:[]
    }),

    computed: {
      ...mapGetters('Login', ['getdatosUsuario']),
    },

    created () {
      this.initialize();
    },

    methods: {
      initialize () {
        this.Loading = true;
        const payload ={
          idmaquilador: this.getdatosUsuario.idusuariosweb,
          idbodegas : this.getdatosUsuario.idbodegas
        }
        this.$http.post('obtener.maquilaciones.usuario', payload).then( response =>{
          this.pedidos = response.body;

          this.pendientes = this.pedidos.filter(e => [1, 2, 3].includes(e.proceso));
          this.porEntregar = this.pedidos.filter(e => e.proceso === 4);
          this.entregados = this.pedidos.filter(e => e.proceso === 5);

          if(this.pendientes.length){
            this.calculateTimeRemaining(); // Calcula el tiempo restante al cargar los pedidos
            setInterval(() => { this.calculateTimeRemaining(); }, 1000); 
          }
        }).catch( error =>{
          console.log('error', error)
        }).finally(()=>{ 
          this.Loading = false
        })
      },

      validarCambioEstatus(proceso, item){
        this.proceso = proceso;
        this.parametros = item;
        this.modalCambioEstatus = true;
      },

      cambiarEstatusMquilador(){
        this.modalCambioEstatus = false;
        this.overlay = true;

        const payload ={
          proceso: this.proceso,
          idseguimiento_pedidos: this.parametros.idseguimiento_pedidos,
          obs: this.obs
        }

        this.$http.post('actualizar.proceso.pedido', payload).then( response =>{
          this.alerta = { activo: true, color:'success', texto: "Pedido iniciado correctamente" };
          this.initialize();
          this.limpiarCampos();
        }).catch( error =>{
          console.log('error', error);
          this.alerta = { activo: true, color:'error', texto: "Ocurrio algun error" };
        }).finally(()=>{ 
          this.overlay = false
        })
      },


      calculateTimeRemaining() {
        const now = new Date();
        this.pendientes.forEach((pedido) => {
          const asignacionMaquilador = new Date(pedido.asignacion_maquilador);
          const tiempoTranscurrido = now - asignacionMaquilador;
          const segundosTranscurridos = Math.floor(tiempoTranscurrido / 1000); // Obtener segundos
          const minutos = Math.floor(segundosTranscurridos / 60);
          const segundos = segundosTranscurridos % 60;
          const horas = Math.floor(minutos / 60);
          const minutosRestantes = minutos % 60;
          let tiempo = '';

          if (horas > 0) {
            tiempo += `${horas.toString().padStart(2, '0')}:`;
          }

          tiempo += `${minutosRestantes.toString().padStart(2, '0')}:${segundos.toString().padStart(2, '0')}`;
          pedido.tiempo = tiempo;
        });
      },


      limpiarCampos(){
        this.proceso = 1;
        this.parametros = {}
        this.obs = ''
      },


      finalizarProceso(){
        this.modalAsignarRepartidor = false; 
        this.initialize();
      }
    },
  }
</script>

<style scoped>
  .normal{
    text-transform: none;
  }

</style>